export const fadeUp = {
  hidden: {
    y: 30,
    opacity: 0,
    transition: {
      ease: [0.42, 0.46, 0.45, 0.99],
      duration: 0.5,
    },
  },
  visible: {
    y: 0,
    opacity: 1,
    transition: {
      ease: [0.42, 0.46, 0.45, 0.99],
      duration: 0.5,
    },
  },
};

export const easeInOut = {
  transition: { type: 'easeinout', duration: 0.25 },
};
